export default {
  title: 'Program de funcționare',
  headers: {
    edit_time: 'Editați ora',
    create_time: 'Creați orar',
  },
  labels: {
    select_all: 'Selectați tot',
    timezone: 'Fus orar',
  },
  fields: {
    selected_days: {
      label: 'Zile selectate',
    },
    opening_time: {
      label: 'Ora de deschidere',
    },
    closing_time: {
      label: 'Ora de închidere',
    },
  },
  columns: {
    days: 'Zile',
    time: 'Oră',
  },
  buttons: {
    add_opening_time: 'Adăugați orar de deschidere',
    add: 'Adăugați',
    cancel: 'Anulați',
    save: 'Salvați',
    close: 'Închideți',
    delete: 'Ștergeți',
    sync_from_online_shop: 'Sincronizați din Online Shop',
  },
  projects: {
    online_shop: 'Online Shop',
    reservations: 'Rezervări',
    storefront: 'Vitrină',
    not_set_up: '{{project}} (nu este configurat pentru această locație)',
  },
  feedback: {
    missing_info: 'Informații lipsă',
  },
  toasts: {
    saving_success: 'Salvat cu succes',
    saving_error: 'Salvarea a eșuat. Verificați informațiile și încercați din nou.',
    sync_success: 'Sincronizat cu succes',
    sync_error: 'Sincronizarea programului din magazinul online a eșuat. Încercați din nou.',
    hours_required: 'Programul de funcționare este obligatoriu. Editați orarul existent',
    not_copied: {
      reservations: {
        not_set_up:
          'Rezervările nu au fost actualizate: rezervările nu sunt încă configurate pentru această locație. Fila Rezervări explică motivul.',
        not_matched:
          'Rezervările nu au fost actualizate: intervalul {{time}} nu există acolo. Verificați programul în fila Rezervări.',
        failed: 'Rezervările nu au putut fi actualizate. Folosiți „Sincronizați din Online Shop” în fila Rezervări.',
      },
      storefront: {
        not_set_up: 'Vitrina nu a fost actualizată: nu a fost găsită nicio vitrină pentru această locație.',
        not_matched:
          'Vitrina nu a fost actualizată: intervalul {{time}} nu există acolo. Verificați programul în fila Vitrină.',
        failed: 'Vitrina nu a putut fi actualizată. Folosiți „Sincronizați din Online Shop” în fila Vitrină.',
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Fus orar',
        },
      },
      toasts: {
        error: 'Actualizarea fusului orar a eșuat',
      },
    },
  },
};
